import { useContext } from "react";
import { MainContext } from "./mainContext";

const useToast = () => useContext(MainContext).setToastActive;

export default useToast;